import { SkeletonShapeVariant, SkeletonVariantType } from './variants';
export const getSkeletonStyles = (FOUNDATIONS) => {
    return {
        [SkeletonShapeVariant.SQUARE]: {
            [SkeletonVariantType.SQUARE_DEFAULT]: {
                skeleton: {
                    border_radius: FOUNDATIONS.radius_100,
                    background_size: '200% 100%',
                    background: `linear-gradient(90deg, ${FOUNDATIONS.color_neutral_bg_skeleton_100} 0%, transparent 45%, ${FOUNDATIONS.color_neutral_bg_skeleton_100} 87%)`,
                },
            },
            [SkeletonVariantType.SQUARE_ON_SURFACE]: {
                skeleton: {
                    border_radius: FOUNDATIONS.radius_100,
                    background_size: '200% 100%',
                    background: `linear-gradient(90deg, ${FOUNDATIONS.color_neutral_bg_skeleton_50} 0%, transparent 45%, ${FOUNDATIONS.color_neutral_bg_skeleton_50} 87%)`,
                },
            },
        },
        [SkeletonShapeVariant.CIRCLE]: {
            [SkeletonVariantType.CIRCLE_DEFAULT]: {
                skeleton: {
                    border_radius: FOUNDATIONS.radius_1000,
                    background_size: '200% 100%',
                    background: `linear-gradient(90deg, ${FOUNDATIONS.color_neutral_bg_skeleton_100} 0%, transparent 45%, ${FOUNDATIONS.color_neutral_bg_skeleton_100} 87%)`,
                },
            },
            [SkeletonVariantType.CIRCLE_ON_SURFACE]: {
                skeleton: {
                    border_radius: FOUNDATIONS.radius_1000,
                    background_size: '200% 100%',
                    background: `linear-gradient(90deg, ${FOUNDATIONS.color_neutral_bg_skeleton_50} 0%, transparent 45%, ${FOUNDATIONS.color_neutral_bg_skeleton_50} 87%)`,
                },
            },
        },
    };
};
//# sourceMappingURL=styles.js.map